import { useMappedConstants } from "@/app/hooks/useMappedConstants";
import clsx from "clsx";
import { startCase } from "lodash";

const BookingStatus: React.FC<{
  bookingStatus: string;
  className?: string;
}> = (props) => {
  const { bookingStatusesColors } = useMappedConstants();
  const statusClassName = bookingStatusesColors[props?.bookingStatus?.toLowerCase()];
  return (
    <div
      className={clsx(
        "justify-center gap-1.5 flex-row items-center opacity-100 px-2 py-1.5 rounded-[20px] flex",
        statusClassName,
      )}
    >
      <span className={`${props?.className}text-xs max-xl:text-[10px] font-normal  text-center tracking-[0px]`}>
        {startCase(props?.bookingStatus)}
      </span>
    </div>
  );
};

export default BookingStatus;
